import { apiSlice } from "./apiSlice";
import {
  GET_WAREHOUSE_STATES_URL,
  SEARCH_PRODUCTS_AND_STORES_URL,
} from "../constants";

export const headerApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchWarehouseStates: builder.query({
      query: () => ({
        url: GET_WAREHOUSE_STATES_URL,
        method: "GET",
      }),
    }),
    searchProductsAndStores: builder.query({
      query: (query) => {
        const location = localStorage.getItem("location") || "";
        return {
          url: SEARCH_PRODUCTS_AND_STORES_URL(query, location), // Use the constant
          method: "GET", // Specify HTTP method
        };
      },
    }),
  }),
});

export const { useFetchWarehouseStatesQuery, useSearchProductsAndStoresQuery } =
  headerApiSlice;
